/** Semantic-layer query endpoint. */
export const SEMANTIC_QUERY_PATH = '/api/v1/semantic/query';
/** Metadata artifacts endpoint (`?kind=SCREEN|FORM|DASHBOARD`). */
export const METADATA_ARTIFACTS_PATH = '/api/v1/platform/metadata/artifacts';
